module.exports = __webpack_public_path__ + "010c1aeee3c6d1cbb1d5761d80353823.woff2";